import type {
  OrderDetail,
  OrderListRow,
} from "@/modules/orders/domain/types";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type OrdersListParams = {
  status?: string;
  branchId?: string;
  channel?: "APP" | "WALKIN";
  createdFrom?: string;
  createdTo?: string;
  pickupFrom?: string;
  pickupTo?: string;
  search?: string;
  sortField?: "createdAt" | "pickupAt" | "total";
  sortOrder?: "asc" | "desc";
  limit?: number;
  offset?: number;
};

export type OrdersListResult = {
  items: OrderListRow[];
  total: number;
};

export type OrdersSummaryParams = {
  branchId?: string;
};

export type OrdersSummary = {
  totalOrdersToday: number;
  pendingConfirmation: number;
  todayRevenue: number;
};

export const ordersApi = {
  async get(id: string): Promise<OrderDetail> {
    return fetcher.get<OrderDetail>(`${config.apiUrl}/orders/${encodeURIComponent(id)}`);
  },

  async summary(
    params: OrdersSummaryParams = {},
  ): Promise<OrdersSummary> {
    const searchParams = new URLSearchParams();
    if (params.branchId) searchParams.set("branchId", params.branchId);
    return fetcher.get<OrdersSummary>(
      `${config.apiUrl}/orders/summary?${searchParams.toString()}`,
    );
  },

  async list(params: OrdersListParams = {}): Promise<OrdersListResult> {
    const searchParams = new URLSearchParams();
    if (params.status) searchParams.set("status", params.status);
    if (params.branchId) searchParams.set("branchId", params.branchId);
    if (params.channel) searchParams.set("channel", params.channel);
    if (params.createdFrom) searchParams.set("createdFrom", params.createdFrom);
    if (params.createdTo) searchParams.set("createdTo", params.createdTo);
    if (params.pickupFrom) searchParams.set("pickupFrom", params.pickupFrom);
    if (params.pickupTo) searchParams.set("pickupTo", params.pickupTo);
    if (params.search) searchParams.set("search", params.search);
    if (params.sortField) searchParams.set("sortField", params.sortField);
    if (params.sortOrder) searchParams.set("sortOrder", params.sortOrder);
    if (params.limit != null) searchParams.set("limit", String(params.limit));
    if (params.offset != null) searchParams.set("offset", String(params.offset));
    return fetcher.get<OrdersListResult>(
      `${config.apiUrl}/orders?${searchParams.toString()}`,
    );
  },
};
